import { tv } from '@/utils/styles';

type Color = 'red' | 'orange' | 'green';

interface Props {
  color?: Color;
  value?: number;
  showAlertIcon?: boolean;
}

const TrafficLight = ({ color = 'red', value = 1, showAlertIcon = false }: Props) => {
  let col = color;
  if (value && value < 0.8) col = 'orange';
  if (value && value < 0.5) col = 'green';

  const { base, alert } = styles();

  return <span className={base({ color: col })}>{showAlertIcon && <span className={alert()} />}</span>;
};

const styles = tv({
  slots: {
    base: 'relative block h-2.5 w-2.5 rotate-45 rounded-sm',
    alert:
      'absolute left-[3px] top-0.5 h-xs w-0.5 -rotate-45 bg-white after:absolute after:left-0 after:top-[5px] after:h-0.5 after:w-0.5 after:bg-white',
  },
  variants: {
    color: {
      red: {
        base: 'bg-status-high',
      },
      orange: {
        base: 'bg-status-medium',
      },
      green: {
        base: 'bg-status-low',
      },
    },
  },
});

export { TrafficLight };
